export default {
  SET_COTACAO(state, cotacao) {
    state.cotacao[cotacao.codigoMoeda] = cotacao;
  },
};
